var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("i", { class: [_vm.type, _vm.name], style: _vm.iconStyle })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }